<template>
    <section>
        <div class="container">
                <div class="row">
                    <div class="footer-advert">
                        <img src="https://bible-esv-140cb.firebaseapp.com/new-ebc-logo.png" alt="holy cross" />
                        <a href="https://ebcbuckley.co.uk/" target="_blank"><p class="ebc">Ebenezer Baptist Church</p></a>
                    </div>
                </div>
        </div>
        <footer style="background-image: url(https://bible-esv-140cb.firebaseapp.com/bodybg3.png);">
            <div class="container">
                <div class="row">
                    <div class="col copyright">
                        <h6>Copyright &copy; <span id="copyright"></span> <a href="https://bible-api.com/" target="_blank">bible-api.com</a> reprinted with permission</h6>
                    </div>
                </div>
            </div>
        </footer>
    </section>
</template>

<script>
    window.onload = () => {
        const theDate = new Date().getFullYear();
        document.getElementById('copyright').innerHTML = theDate;
    }
</script>



// WEBPACK FOOTER //
// src/components/TheFooter.vue